@if (pushes?.length > 0) {
  <sd-component-wrapper
    [content]="wrapperContent"
    [themesConfig]="lameConfig?.bundlesOrProducts?.backgroundTheme"
    [brand]="brand"
  >
    <div sd-component-wrapper-component
      class="c__bundle-push row {{ pushes.length > 3 ? 'is-horizontal-layout' : '' }} {{ pushes?.length > 0 ? '' : 'justify-content-center'}}"
    >
      @if (pushes?.length > 0) {
        <div class="c__bundles {{ !!promoPush ? '' : 'col-l-24' }}">
          <div class="row c__bundles-wrapper {{ !!promoPush ? '' : 'justify-content-center' }}">
            @for (push of pushes; track $index) {
              <sd-push-card
                [pushSize]="pushSizeEnum.xs"
                [push]="push"
                [isDescription]="false"
                [titleLevel]="3"
                [subtitleLevel]="7"
                [themesConfig]="themesConfig"
                [textConfig]="textConfig"
                [mediaConfig]="mediaConfig"
                [mediaAsBackground]="false"
                [imageRatio]="imageRatio"
                [isFit]="true"
                [indexFollow]="push?.indexFollow"
                [brand]="brand"
                (clicked)="onBundlePackClick(push.richParagraph?.heading?.data?.title)"
              />
            }
          </div>
        </div>
      }
      @if (!!promoPush) {
        <div class="c__push-m">
          <sd-push-card
            #pushCardComponent
            [pushSize]="pushSizeEnum.m"
            class=" {{ pushes?.length > 3 ? 'col-24 col-l-12 justify-content-center' : 'col-24 col-l-12' }}"
            [push]="promoPush.push"
            [themesConfig]="promoPush.themesConfig"
            [mediaAsBackground]="promoPush.mediaAsBackground"
            [mediaConfig]="promoPush.mediaConfig"
            [textConfig]="promoPush.textConfig"
            [imageRatio]="promoPush.imageRatio"
            [brand]="brand"
            (click)="onPromoClick()"
          />
        </div>
      }
    </div>
  </sd-component-wrapper>
}
